import React from "react";

import RoleAccordion from "./RoleExplainerAccordion";

interface RoleExplanations {
	role_summary: string;
	what_you_will_do: string[];
	what_you_need: string[];
	how_to_apply: {
		instructions: string;
		include: string[];
	};
	cta_fit_check: string;
}

function RoleExplainer({ roleExplanations, loading }: { roleExplanations?: RoleExplanations; loading: boolean }) {
	const enContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<h3 className="font-semibold">Summary</h3>
				<p className="mt-1">{roleExplanations.role_summary || "No summary provided."}</p>

				{/* What You’ll Do */}
				<h3 className="font-semibold mt-5">What You’ll Do</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_will_do || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<h3 className="font-semibold mt-5">What You Need</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_need || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				{/* How to Apply */}
				<h3 className="font-semibold">How to Apply</h3>
				<p className="mt-1">
					{roleExplanations?.how_to_apply?.instructions || "No application instructions provided."}
				</p>

				<h2 className="font-semibold mt-5">Include:</h2>
				<ul className="list-disc pl-5">
					{(roleExplanations?.how_to_apply?.include || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				<p>
					<a href="#">Fit check me</a> and We will tell you how well you match the role.
				</p>
			</>
		) : (
			<p className="mt-1">No role explainer for this job.</p>
		);

	const swContent = <p className="mt-1">Tafsiri ya Kiswahili itakuja hivi karibuni.</p>;

	return (
		<RoleAccordion
			title={loading ? "Loading Role Explainer ...." : "Role Explainer"}
			content={{
				en: loading ? <p>Loading...</p> : enContent,
				sw: swContent,
			}}
		/>
	);
}

export default RoleExplainer;
